<template>
  <div class="signup-page">
    <div class="signup-page__left">
      <div class="signup-page__title">Thanks for<br />Signing Up!</div>
      <div class="signup-page__desc">
        Your profile has been added to the virtual network. Enjoy making
        connections as you enjoy the conference.
      </div>
      <v-btn color="jude_lightred" to="/networking">
        View Networking Page
      </v-btn>
    </div>
    <div class="signup-page__right">
      <div class="signup-page__img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SignupThanksPage",
  metaInfo: {
    titleTemplate: "%s - SignUp Thanks",
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.signup-page {
  display: flex;
  background-color: #f5f5f5;
  color: $primary;
  height: 100%;

  &__left {
    flex: 1;
    padding: 125px 50px 0;
  }

  &__right {
    flex: 1;
    height: 100%;
  }

  &__img {
    width: 100%;
    height: 100%;
    background-image: url(~@/assets/signup-thanks.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  &__title {
    font-weight: 800;
    font-size: 64px;
    line-height: 73px;
  }

  &__desc {
    margin: 39px 0 60px;
    font-size: 18px;
    line-height: 24px;
    color: #000000;
  }
}

@media screen and (max-width: 960px) {
  .signup-page {
    flex-direction: column;
  }
}
</style>
